module.exports = __webpack_public_path__ + "static/media/ic_youtube.28c79ae9.svg";